// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lDWz","clinicsSelect":"styles_clinicsSelect__34ZRB"};